<div class="d-flex flex-column" *ngIf="!!item">
  <div class="d-flex flex-column my-3">
    <h6>{{item.productName}}</h6>
    <div class="d-flex">
      <img style="width: 180px; padding: 10px" [src]="(item.picture || item.drawing) | imgFromBytes" alt="">

      <div class="d-flex flex-column">
        <small class="me-2">Bidirectional:</small>
        <small class="me-2">Minimum Metal:</small>
        <small class="me-2">Operating Temperature:</small>
        <small class="me-2">Flow Speed:</small>
        <small class="me-2">Maximum Run Length:</small>
        <small class="me-2">Minimum Bend Radius:</small>
      </div>
      <div class="d-flex flex-column">
        <small>{{item.bidirectional ? 'Yes' : 'No'}}</small>
        <small>{{item.minimumMetal ? 'Yes' : 'No'}}</small>
        <small [innerHTML]="item.operatingTemp"></small>
        <small>{{item.flowSpeed}}</small>
        <small>{{item.maxRunLength}}</small>
        <small>{{item.minBendRadiusText}}</small>
      </div>
    </div>
  </div>

</div>


<ng-template #keyvalue let-obj>

</ng-template>
